export default __webpack_public_path__ + "static/media/notification_icon.66c6248a.png";